export const setCookie = (name: string, value: string, days: number = 30) => {
  const expires = new Date();
  expires.setTime(expires.getTime() + days * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
};

export const getCookie = (name: string): string | null => {
  const nameEQ = name + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};

export const setLocalStorage = (key: string, value: any) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error('Error saving to localStorage:', error);
  }
};

export const getLocalStorage = (key: string, defaultValue: any = null) => {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : defaultValue;
  } catch (error) {
    console.error('Error reading from localStorage:', error);
    return defaultValue;
  }
};

export const removeLocalStorage = (key: string) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error('Error removing from localStorage:', error);
  }
};

// Track returning visitors
export const trackVisitor = () => {
  const isReturning = getCookie('contax-returning-visitor') === 'true';
  
  if (!isReturning) {
    setCookie('contax-returning-visitor', 'true', 30);
  }
  
  return isReturning;
};

// Track page views and engagement
export const trackPageView = () => {
  const pageViews = getLocalStorage('contax-page-views', 0);
  setLocalStorage('contax-page-views', pageViews + 1);
  
  // Track session start time
  if (!sessionStorage.getItem('contax-session-start')) {
    sessionStorage.setItem('contax-session-start', Date.now().toString());
  }
};

export const getEngagementData = () => {
  const pageViews = getLocalStorage('contax-page-views', 0);
  const sessionStart = sessionStorage.getItem('contax-session-start');
  const timeOnPage = sessionStart ? Date.now() - parseInt(sessionStart) : 0;
  
  return {
    pageViews,
    timeOnPage: Math.floor(timeOnPage / 1000), // in seconds
    isReturningVisitor: getCookie('contax-returning-visitor') === 'true'
  };
};